import React from "react";
import "./Input.css";

const InputWrapper = ({ label, required = false, children, className = "" ,style ={} }) => {
  return (
    <div style={style} className={`input-wrapper ${className}`}>
      {label && (
        <label className="input-wrapper-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className="input-wrapper-content">{children}</div>
    </div>
  );
};

export default InputWrapper;
